import ApiClient from './ApiClient';

class ErpCatalogs extends ApiClient {
  constructor() {
    super('erp/catalogs', { accountScoped: true });
  }

  testConnection(payload) {
    // POST /api/v1/accounts/:account_id/erp/catalogs/test_connection
    return window.axios.post(`${this.url}/test_connection`, payload);
  }

  listSchemas(payload) {
    return window.axios.post(`${this.url}/schemas`, payload);
  }

  listTables(payload) {
    return window.axios.post(`${this.url}/tables`, payload);
  }

  listColumns(payload) {
    return window.axios.post(`${this.url}/columns`, payload);
  }

  listCatalogs() {
    return window.axios.get(this.url);
  }

  createCatalog(payload) {
    return window.axios.post(this.url, payload);
  }

  deleteCatalog(catalogId) {
    return window.axios.delete(`${this.url}/${catalogId}`);
  }

  updateCatalog(catalogId, payload) {
    return window.axios.patch(`${this.url}/${catalogId}`, payload);
  }

  reorderCatalogs(payload) {
    return window.axios.post(`${this.url}/reorder`, payload);
  }

  listRecords(catalogId, payload) {
    return window.axios.post(`${this.url}/${catalogId}/records`, payload);
  }

  createRecord(catalogId, payload) {
    return window.axios.post(`${this.url}/${catalogId}/records/create`, payload);
  }

  updateRecord(catalogId, payload) {
    return window.axios.post(`${this.url}/${catalogId}/records/update`, payload);
  }

  deleteRecord(catalogId, payload) {
    return window.axios.post(`${this.url}/${catalogId}/records/delete`, payload);
  }

  reconnectCatalog(catalogId) {
    return window.axios.post(`${this.url}/${catalogId}/reconnect`);
  }
}

export default new ErpCatalogs();

